globalThis.ProfileEditor = class ProfileEditor {
  constructor() {
    this.abort = new AbortController();
    this.div = document.createElement("div");
    this.div.id = "profile-editor";
    this.icon = document.createElement("div");
    this.icon.classList.add("player", "remote");
    this.body = document.createElement("div");
    this.body.classList.add("body");
    this.name = document.createElement("input");
    this.id = document.createElement("small");
    this.body.append(this.name, this.id);
    this.div.append(this.icon, this.body);
    this.name.addEventListener("blur", this.onBlur.bind(this), this.abort);
    this.name.addEventListener("keydown", this.onKey.bind(this), this.abort);
    addEventListener("store", this.onStore.bind(this), this.abort);
    this.update();
  }

  remove() {
    this.abort.abort();
    this.div.remove();
  }

  onBlur() {
    if (this.name.value) {
      globalThis.STORE.profile.name = this.name.value;
      globalThis.STORE.saveProp("profile");
    }
    this.update();
  }

  onKey(event) {
    if ([13, 27].includes(event.keyCode)) this.name.blur();
    else this.name.value = this.name.value.substring(0, 16);
  }

  onStore(event) {
    if (event.detail === "profile") this.update();
  }

  update() {
    this.name.value = globalThis.STORE.profile.name;
    this.id.innerText = globalThis.STORE.profile.id;
  }
};
